import { defineComponent, onMounted, onUnmounted } from 'vue';
import EntitiesAndGeotargeting from '@/presentation/components/entities-and-geotargeting/entities-and-geotargeting.vue';
import EntitiesAndGeotargetingCode from '@/presentation/pages/entities-and-geotargeting/entities-and-geotargeting.code';

export default defineComponent({
	components: {
		EntitiesAndGeotargeting
	},
	setup: () => {
		const code = new EntitiesAndGeotargetingCode();

		onMounted(code.mounted.bind(code));
		onUnmounted(code.unmounted.bind(code));

		return {
			isCampaignTypeCustomProducts: code.isCampaignTypeCustomProducts
		};
	}
});
